export const FETCH_SUBMITTED_TO_TYPIST = "[MIS] FETCH_SUBMITTED_TO_TYPIST";
export const FETCH_SUBMITTED_TO_TYPIST_START = "[MIS] FETCH_SUBMITTED_TO_TYPIST_START";
export const FETCH_SUBMITTED_TO_TYPIST_SUCCESS = "[MIS] FETCH_SUBMITTED_TO_TYPIST_SUCCESS";
export const FETCH_SUBMITTED_TO_TYPIST_ERROR = "[MIS] FETCH_SUBMITTED_TO_TYPIST_ERROR";

export const SET_SUBMITTED_TO_TYPIST_FILTER = "[MIS] SET_SUBMITTED_TO_TYPIST_FILTER";

export const SET_SUBMITTED_TO_TYPIST_PAGINATION = "[MIS] SET_SUBMITTED_TO_TYPIST_PAGINATION";

export const VIEW_STT_VISIT_LOADING_START = "[MIS] VIEW_STT_VISIT_LOADING_START";
export const VIEW_STT_VISIT_LOADING_END = "[MIS] VIEW_STT_VISIT_LOADING_END";
export const RESET_STT_FILTER = "[MIS] RESET_STT_FILTER";

export const fetchMisSubmittedToTypist = (payload) => {
    return {
        type: FETCH_SUBMITTED_TO_TYPIST,
        payload
    };
};

export const setMisSubmittedToTypistFilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_SUBMITTED_TO_TYPIST_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const resetSubmittedToTypistFilter = () => {
    return {
        type: RESET_STT_FILTER,
    };
}
